import { Link } from "react-router-dom";
import { PropertyEndpoint } from "../../../api";
import { useState, useEffect } from "react";
import { Modal, Button, Form, Input, InputNumber, message, List, Space } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { getBaseUrl } from "../../../api/baseApi";

const BASE_URL = getBaseUrl();

const getImageUrl = (photo) => {
    if (!photo) return "";

    try {
        // Coba parse JSON array
        const parsed = JSON.parse(photo);
        if (Array.isArray(parsed) && parsed.length > 0) {
            return BASE_URL + parsed[0]; // gunakan gambar pertama
        }
    } catch (err) {
        // Jika bukan JSON → gunakan langsung
        return BASE_URL + photo;
    }

    return ""; // fallback
};

function MyProperty({ userData }) {
    let publicUrl = process.env.PUBLIC_URL + "/";
    const propertyEndpoint = new PropertyEndpoint();

    const [propertyData, setPropertyData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [managerModalVisible, setManagerModalVisible] = useState(false);
    const [editModalVisible, setEditModalVisible] = useState(false);
    const [selectedProperty, setSelectedProperty] = useState(null);
    const [inviteEmail, setInviteEmail] = useState('');
    const [managers, setManagers] = useState([]);
    const [searchText, setSearchText] = useState('');
    const itemsPerPage = 5;

    const [editingProperty, setEditingProperty] = useState(null);
    const [form] = Form.useForm();
    const propertyApi = new PropertyEndpoint();

    // FETCH DATA
    useEffect(() => {
        const fetchPropertyData = async () => {
            try {
                const response = await propertyApi.getProperties();
                const filtered = response.filter((property) =>
                    property.property_users.some(
                        (pu) => pu.user_id === userData.id && pu.relation_type === "owner"
                    )
                );
                console.log(filtered);

                setPropertyData(filtered);
            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        };
        fetchPropertyData();
    }, [userData.id]);

    // ============================
    // FUNCTIONS PENGELOLA
    // ============================

    const getPengelola = async (property) => {
        try {
            const response = await propertyEndpoint.getOfficer(property.id, property.property_type);

            // Normalisasi response
            const managerList = response.map(m => ({
                id: m.id,
                property_id: m.property_id,
                relation_type: m.relation_type,
                email: m.user?.email || "",
                name: m.user?.name || "",
                user: m.user
            }));

            setManagers(managerList);

        } catch (err) {
            console.error("Error fetching officers:", err);
            message.error("Failed to load managers");
        }
    };

    const addOfficer = async (email) => {
        if (!email) return;
        try {
            await propertyEndpoint.addOfficer({
                property_id: selectedProperty.id,
                email
            });
            message.success("Manager invited successfully");
            setInviteEmail('');
            getPengelola(selectedProperty); // refresh list
        } catch (err) {
            console.error("Error adding officer:", err);
            message.error("Failed to invite manager");
        }
    };

    const handleDeleteManager = async (id,) => {
        try {
            await propertyEndpoint.deleteOfficer(id, selectedProperty.id);
            message.success("Manager removed successfully");
            getPengelola(selectedProperty);
        } catch (err) {
            console.error("Error removing officer:", err);
            message.error("Failed to remove manager");
        }
    };

    const openManagerModal = (property) => {
        setSelectedProperty(property);
        getPengelola(property);
        setManagerModalVisible(true);
    };

    // Pagination
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = propertyData.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(propertyData.length / itemsPerPage);

    const changePage = (page) => {
        if (page >= 1 && page <= totalPages) setCurrentPage(page);
    };

    // OPEN MODAL
    const openEditModal = (property) => {
        setEditingProperty(property);
        setEditModalVisible(true);
        form.setFieldsValue({
            name: property.name,
            city: property.city,
            province: property.province,
            rent_price: property.rent_price,
            deposit: property.deposit,
        });
    };

    const handleUpdate = async (values) => {
        if (!editingProperty) return;

        setLoading(true);

        try {
            const payload = {
                type: editingProperty.property_type,
                property_data: {
                    name: values.name,
                    city: values.city,
                    province: values.province,
                },
                detail_data: {
                    rent_price: values.rent_price,
                    deposit: values.deposit,
                },
            };

            await propertyApi.updateProperty(editingProperty.id, payload);

            // Update state lokal
            setPropertyData((prev) =>
                prev.map((p) =>
                    p.id === editingProperty.id
                        ? { ...p, ...payload.property_data, ...payload.detail_data }
                        : p
                )
            );

            setEditModalVisible(false);
            setEditingProperty(null);
            message.success("Properti berhasil diperbarui!");
        } catch (err) {
            console.error(err);
            message.error(
                err.response?.data?.message || "Terjadi kesalahan saat memperbarui properti"
            );
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="text-center py-5">
                <h6>Loading your properties...</h6>
            </div>
        );
    }

    const filteredManagers = managers.filter(m =>
        m.user?.email?.toLowerCase().includes(searchText.toLowerCase()) ||
        m.user?.name?.toLowerCase().includes(searchText.toLowerCase())
    );

    if (!loading && propertyData.length === 0) {
        return (
            <div>
                <div className="ltn__myaccount-tab-content-inner">
                    <p className="text-center py-5">You have no properties yet.</p>
                </div>
            </div>
        );
    }
    return (
        <div>
            <div className="ltn__myaccount-tab-content-inner">
                <div className="ltn__my-properties-table table-responsive">
                    <table className="table">
                        <thead>
                            <tr>
                                <th scope="col">My Properties</th>
                                <th scope="col" />
                                <th scope="col">Date Added</th>
                                <th scope="col">Actions</th>
                                <th scope="col">Property Managers</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentItems.map((property, index) => (
                                <tr key={index}>
                                    <td className="ltn__my-properties-img go-top">
                                        {/* Ganti Link dengan div untuk modal */}
                                        <img
                                            src={getImageUrl(property.photo)}
                                            alt={property.name}
                                            style={{ width: "100px", height: "80px", objectFit: "cover", borderRadius: 6 }}
                                            onError={(e) => {
                                                // fallback jika URL foto error
                                                e.target.src = publicUrl + "assets/img/product-3/2.jpg";
                                            }}
                                        />
                                    </td>

                                    <td>
                                        <div className="ltn__my-properties-info">
                                            <h6 className="mb-10 go-top">
                                                <div
                                                    style={{ cursor: "pointer" }}
                                                    onClick={() => openEditModal(property)}
                                                >
                                                    {property.name}
                                                </div>
                                            </h6>
                                            <small>
                                                <i className="icon-placeholder" /> {property.city},{" "}
                                                {property.province}
                                            </small>
                                        </div>
                                    </td>

                                    <td>Feb 22, 2022</td>
                                    <td>
                                        <Button type="link" onClick={() => openEditModal(property)}>
                                            Edit
                                        </Button>
                                    </td>
                                    <td>
                                        <Button type="primary" onClick={() => openManagerModal(property)}>
                                            Kelola
                                        </Button>
                                    </td>
                                </tr >
                            ))
                            }
                        </tbody >
                    </table >
                </div >

                {/* Pagination */}
                <div className="ltn__pagination-area text-center">
                    <div className="ltn__pagination">
                        <ul>
                            <li>
                                <Link onClick={() => changePage(currentPage - 1)}>
                                    <i className="fas fa-angle-double-left" />
                                </Link>
                            </li>
                            {[...Array(totalPages)].map((_, i) => (
                                <li key={i} className={currentPage === i + 1 ? "active" : ""}>
                                    <Link onClick={() => changePage(i + 1)}>{i + 1}</Link>
                                </li>
                            ))}
                            <li>
                                <Link onClick={() => changePage(currentPage + 1)}>
                                    <i className="fas fa-angle-double-right" />
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div >

                {/* Manager Modal */}
                <Modal
                    title="List Pengelola"
                    open={managerModalVisible}
                    onCancel={() => {
                        setManagerModalVisible(false);
                        setSelectedProperty(null);
                        setInviteEmail('');
                        setSearchText('');
                    }}
                    footer={null}
                >
                    <Space style={{ marginBottom: 16 }}>
                        <Input
                            placeholder="Enter email"
                            value={inviteEmail}
                            onChange={e => setInviteEmail(e.target.value)}
                        />
                        <Button type="primary" onClick={() => addOfficer(inviteEmail)}>Invite</Button>
                    </Space>

                    <Input
                        placeholder="Search manager"
                        value={searchText}
                        onChange={e => setSearchText(e.target.value)}
                        style={{ marginBottom: 16 }}
                    />

                    <List
                        bordered
                        dataSource={filteredManagers}
                        renderItem={item => (
                            <List.Item
                                actions={[
                                    <Button
                                        type="link"
                                        danger
                                        icon={<DeleteOutlined />}
                                        onClick={() => handleDeleteManager(item.user?.id)}
                                    />
                                ]}
                            >
                                <div>
                                    <strong>{item.user?.name}</strong>
                                    <div style={{ fontSize: 12, color: "#666" }}>
                                        {item.user?.email}
                                    </div>
                                </div>
                            </List.Item>
                        )}
                    />
                </Modal>

                {/* Edit Property Modal */}
                <Modal
                    title="Edit Property"
                    open={editModalVisible}
                    onCancel={() => {
                        setEditModalVisible(false);
                        setEditingProperty(null);
                        form.resetFields();
                    }}
                    footer={null}
                >
                    <Form form={form} layout="vertical" onFinish={handleUpdate}>
                        <Form.Item label="Property Name" name="name" rules={[{ required: true }]}>
                            <Input />
                        </Form.Item>
                        <Form.Item label="City" name="city" rules={[{ required: true }]}>
                            <Input />
                        </Form.Item>
                        <Form.Item label="Province" name="province" rules={[{ required: true }]}>
                            <Input />
                        </Form.Item>
                        <Form.Item label="Rent Price (IDR)" name="rent_price">
                            <InputNumber style={{ width: "100%" }} />
                        </Form.Item>
                        <Form.Item label="Deposit (IDR)" name="deposit">
                            <InputNumber style={{ width: "100%" }} />
                        </Form.Item>
                        <Form.Item>
                            <Button type="primary" htmlType="submit" block loading={loading}>
                                Update Property
                            </Button>
                        </Form.Item>
                    </Form>
                </Modal>
            </div >
        </div>
    );
}

export default MyProperty;
